import script from "./ChronologySingle.vue?vue&type=script&setup=true&lang=js"
export * from "./ChronologySingle.vue?vue&type=script&setup=true&lang=js"

import "./ChronologySingle.vue?vue&type=style&index=0&id=1318464e&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1318464e"]])

export default __exports__